import {
	DEFAULT_CONNECTION_STRATEGY,
	DEFAULT_CONNECTION_DISPLAY_MODE,
	normalizeWorkspaceModePreference,
	type ConnectionDisplayMode,
	type ConnectionStrategy,
	type Preferences,
	type PreferencesRepository,
	type WorkspaceModePreference,
} from '../ports/preferences-repository';
export class PreferencesService {
  constructor(private repository: PreferencesRepository) {}
  async getLocale(): Promise<Preferences['locale']> { return (await this.repository.get('locale')) ?? 'zh-TW'; }
  async setLocale(locale: Preferences['locale']): Promise<void> { await this.repository.set('locale', locale); }
  async getConnectionStrategy(): Promise<ConnectionStrategy> { return (await this.repository.get('connectionStrategy')) ?? DEFAULT_CONNECTION_STRATEGY; }
  async setConnectionStrategy(connectionStrategy: ConnectionStrategy): Promise<void> { await this.repository.set('connectionStrategy', connectionStrategy); }
  async getConnectionDisplayMode(): Promise<ConnectionDisplayMode> { return (await this.repository.get('connectionDisplayMode')) ?? DEFAULT_CONNECTION_DISPLAY_MODE; }
  async setConnectionDisplayMode(connectionDisplayMode: ConnectionDisplayMode): Promise<void> { await this.repository.set('connectionDisplayMode', connectionDisplayMode); }
  async getWorkspaceModePreference(): Promise<WorkspaceModePreference> {
    return normalizeWorkspaceModePreference({
      workspaceMode: await this.repository.get('workspaceMode'),
      lastGraphMode: await this.repository.get('lastGraphMode'),
    });
  }
  async setWorkspaceModePreference(preference: WorkspaceModePreference): Promise<void> {
    const normalized = normalizeWorkspaceModePreference(preference);
    await this.repository.save({
      workspaceMode: normalized.workspaceMode,
      lastGraphMode: normalized.lastGraphMode,
    });
  }
}
